import React, { Fragment } from "react";
import ReactPaginate from "react-paginate";
import _ from "lodash";
import ReactTooltip from "react-tooltip";

import Table from "../../common/components/Table";
import TableTopIcons from "../../common/components/TableTopIcons";

const BuildingLeaseMain = ({
    showWildCardFilter,
    paginationParams,
    currentViewAllUsers,
    showViewModal,
    tableData,
    handleGlobalSearch,
    toggleWildCardFilter,
    updateCurrentViewAllUsers,
    handleDeleteLease,
    showEditPage,
    handlePerPageChange,
    handlePageClick,
    showAddForm,
    showInfoPage,
    updateSelectedRow,
    selectedRowId,
    globalSearchKey,
    updateWildCardFilter,
    wildCardFilter,
    handleHideColumn,
    getListForCommonFilterLease,
    updateCommonFilter,
    commonFilter,
    resetAllFilters,
    resetAll,
    updateTableSortFilters,
    resetSort,
    tableParams,
    permissions,
    showAddButton,
    hasExport,
    hasEdit,
    hasDelete,
    hasInfoPage,
    entity,
    summaryRowData,
    isInputMode,
    handleCellFocus,
    handleCellValueChange,
    lineEditingEnabled,
    toggleLineEditing,
    handleColumnPin,
    pinnedColumnsRef,
    tableLoading,
    exportTableXl,
    unPinAllColumn,
    hasViewIcon,
    handleRowClick
}) => {
    return (
        <Fragment>
            <div className="col-md-12 floor-detail addition-hght-overflow">
                <div className="table-top-menu allign-right">
                    <div className="rgt">
                        <TableTopIcons
                            tableData={tableData}
                            globalSearchKey={globalSearchKey}
                            handleGlobalSearch={handleGlobalSearch}
                            resetAllFilters={resetAllFilters}
                            resetAll={resetAll}
                            toggleWildCardFilter={toggleWildCardFilter}
                            showViewModal={showViewModal}
                            resetSort={resetSort}
                            tableParams={tableParams}
                            tableLoading={tableLoading}
                            exportTableXl={exportTableXl}
                            isExport={hasExport}
                            entity={entity}
                            showWildCardFilter={showWildCardFilter}
                            hasTableCellEdit={false}
                            toggleLineEditing={toggleLineEditing}
                            lineEditingEnabled={lineEditingEnabled}
                            unPinAllColumn={unPinAllColumn}
                        />
                        {showAddButton && (
                            <button className="add-btn" onClick={showAddForm}>
                                <i className="fas fa-plus" /> Add New Lease
                            </button>
                        )}
                    </div>
                </div>
                <Table
                    updateCurrentViewAllUsers={updateCurrentViewAllUsers}
                    tableData={tableData}
                    summaryRowData={summaryRowData}
                    currentViewAllUsers={currentViewAllUsers}
                    handleDeleteItem={handleDeleteLease}
                    showWildCardFilter={showWildCardFilter}
                    showEditPage={showEditPage}
                    showInfoPage={showInfoPage}
                    updateSelectedRow={updateSelectedRow}
                    selectedRowId={selectedRowId}
                    updateWildCardFilter={updateWildCardFilter}
                    wildCardFilter={wildCardFilter}
                    handleHideColumn={handleHideColumn}
                    getListForCommonFilter={getListForCommonFilterLease}
                    updateCommonFilter={updateCommonFilter}
                    commonFilter={commonFilter}
                    updateTableSortFilters={updateTableSortFilters}
                    tableParams={tableParams}
                    permissions={permissions}
                    hasEdit={hasEdit}
                    hasDelete={hasDelete}
                    hasInfoPage={hasInfoPage}
                    isInputMode={isInputMode}
                    handleCellFocus={handleCellFocus}
                    handleCellValueChange={handleCellValueChange}
                    handleColumnPin={handleColumnPin}
                    pinnedColumnsRef={pinnedColumnsRef}
                    hasPin={true}
                    lineEditingEnabled={lineEditingEnabled}
                    hasViewIcon={hasViewIcon}
                    isNewTableFilters={false}
                    noFutureDate={true}
                />

                {tableData?.data?.length > 0 && (
                    <div className="table-bottom d-flex">
                        <div className="count d-flex col-md-6">
                            <div className="count-dtl">
                                Total Count: <span>{paginationParams.totalCount}</span>
                            </div>
                            <div className="col-md-2 pr-2 selbx">
                                <select className="form-control" value={paginationParams.perPage} onChange={handlePerPageChange}>
                                    {[10, 20, 30, 40, 50, 100, 150].map(val => (
                                        <option key={val} value={val}>
                                            {val}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div className="pagination-sec col-md-6">
                            <ReactPaginate
                                previousLabel={
                                    <span data-place="top" data-effect="solid" data-tip="Previous" data-background-color="#007bff">
                                        &lt;
                                    </span>
                                }
                                nextLabel={
                                    <span data-place="top" data-effect="solid" data-tip="Next" data-background-color="#007bff">
                                        &gt;
                                    </span>
                                }
                                breakLabel="..."
                                breakClassName="break-me"
                                pageCount={paginationParams.totalPages}
                                marginPagesDisplayed={2}
                                pageRangeDisplayed={5}
                                onPageChange={handlePageClick}
                                containerClassName="pagination"
                                subContainerClassName="pages pagination"
                                activeClassName="active"
                                activeLinkClassName="active"
                                forcePage={paginationParams.currentPage}
                            />
                            <ReactTooltip />
                        </div>
                    </div>
                )}
            </div>
        </Fragment>
    );
};

export default BuildingLeaseMain;
